import { render, staticRenderFns } from "./statementTemplateDetail.vue?vue&type=template&id=02a7e8b3&scoped=true"
import script from "./statementTemplateDetail.vue?vue&type=script&lang=js"
export * from "./statementTemplateDetail.vue?vue&type=script&lang=js"
import style0 from "./statementTemplateDetail.vue?vue&type=style&index=0&id=02a7e8b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a7e8b3",
  null
  
)

export default component.exports